import { Injectable } from '@angular/core';
import { environment } from '@root/environments/environment';

interface WindowWithAdrum extends Window {
  'adrum-start-time'?: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  'adrum-config'?: any;
}

@Injectable({
  providedIn: 'root',
})
export class AppDynamicsService {
  private isLoaded = false;

  public initializeAdrum(): void {
    this.loadAdrumIfNeeded();
  }

  private loadAdrumIfNeeded(): void {
    // Only load adrum if not in development environment
    if (!environment.isDevelopment && !this.isLoaded) {
      this.loadAdrumScript();
      this.isLoaded = true;
    }
  }

  private loadAdrumScript(): void {
    const windowWithAdrum = window as WindowWithAdrum;

    // Set adrum start time
    windowWithAdrum['adrum-start-time'] = new Date().getTime();

    // Configure adrum
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (function (config: any) {
      config.appKey = environment.appDynamicsKey;
      config.adrumExtUrlHttp = 'http://cdn.appdynamics.com';
      config.adrumExtUrlHttps = 'https://cdn.appdynamics.com';
      config.beaconUrlHttp = 'http://appdeum.se.com.sa:7001';
      config.beaconUrlHttps = 'https://appdeum.se.com.sa:443';
      config.xd = { enable: false };
    })(
      windowWithAdrum['adrum-config'] || (windowWithAdrum['adrum-config'] = {})
    );

    // Load adrum script dynamically
    const script = document.createElement('script');
    script.src = '//cdn.appdynamics.com/adrum/adrum-24.4.0.4454.js';
    script.async = true;
    document.head.appendChild(script);
  }
}
